import React, { useRef } from "react";

import { Map } from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import MapContent from "./map-content/MapContent";
import "leaflet/dist/leaflet.css";
import "./DevicesMap.scss";

const DevicesMap = () => {
    const mapRef = useRef<Map | null>(null);
    return (
      <div className="relative">
        <MapContainer
          id="map"
          scrollWheelZoom
          doubleClickZoom={false}
          zoomControl={false}
          ref={mapRef}
          maxZoom={18}
          minZoom={5}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MapContent />
        </MapContainer>
      </div>
    );
};

export default DevicesMap;
